<template>
  <el-dialog
    title="Edit Asset"
    :visible.sync="isVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="closable"
    @closed="$emit('destroy')"
  >
    <el-dialog
      width="30%"
      title="Notice"
      :visible="isPrompting && isVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      append-to-body
    >
      Are you sure you want to delete Asset <b>{{ asset.serial }}</b>?

      <div slot="footer">
        <el-button
          type="primary"
          :disabled="!closable"
          @click.native="isPrompting = false"
        >
          No
        </el-button>

        <el-button
          :disabled="!closable"
          @click.native="deleteAsset"
        >
          Yes
        </el-button>
      </div>
    </el-dialog>

    <AssetEditForm
      v-loading="isProcessing"
      :asset="asset"
    />

    <template #footer>
      <el-button
        :disabled="!closable"
        @click.native="isVisible = false"
      >
        Cancel
      </el-button>

      <el-button
        :disabled="!closable"
        type="danger"
        @click.native="isPrompting = true"
      >
        Delete
      </el-button>

      <el-button
        type="primary"
        :disabled="!closable"
        @click.native="updateAsset"
      >
        Save
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import AssetEditForm from '@/components/Application/Manage/Assets/Asset/EditForm'

export default {
  components: {
    AssetEditForm
  },
  props: {
    asset: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isVisible: true,
      isProcessing: false,
      isPrompting: false
    }
  },
  computed: {
    closable () {
      return !this.isProcessing
    }
  },
  methods: {
    async deleteAsset () {
      this.isProcessing = true

      try {
        await this.asset.delete()
        this.$message.success(`Deleted Asset ${this.asset.serial}`)
      } finally {
        this.isVisible = false
      }
    },
    async updateAsset () {
      this.isProcessing = true

      try {
        await this.asset.save()
        this.$message.success(`Updated Asset ${this.asset.serial}`)
      } finally {
        this.isVisible = false
      }
    }
  }
}
</script>
